// UI labels for sections and buttons
export const LABELS = {
  CARRIER_IMAGES: 'Carrier Images',
  PRO_IMAGES: 'Pro Images',
  ALL_IMAGES: 'All Images',
  VIEW_PRO_IMAGES: 'View Pro Images',
} as const;

// User-facing messages
export const MESSAGES = {
  LOADING: 'Loading images...',
  NO_IMAGES_FOUND: 'No images found',
  NOT_AVAILABLE: 'Not Available',
  ERROR_FETCHING_IMAGES: 'Error while fetching images',
  RETRY: 'Retry',
  PRO_NUMBER_NOT_AVAILABLE: 'PRO number not available',
  FAILED_TO_FETCH_IMAGES: 'Failed to fetch images',
  FAILED_TO_LOAD_IMAGES: 'Failed to load images',
} as const;

// Modal/dialog titles
export const TITLES = {
  IMAGES_FOR_PRO: (proNumber: string) => `Images for Pro : ${proNumber || ''}`,
} as const;

export const DEFAULT_CONFIG = {
  loading: {
    message: MESSAGES.LOADING,
  },
  error: {
    retryButtonText: MESSAGES.RETRY,
  },
  empty: {
    message: MESSAGES.NO_IMAGES_FOUND,
  },
};
